import React from 'react';

import DesktopNav from './DesktopNav';
import MobileNav from './MobileNav';

export default ({ location }) => {
  return (
    <React.Fragment>
      <DesktopNav />
      <MobileNav />
    </React.Fragment>
  )
}